import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PackageSelection from 'components/ShipmentSettings/PackageSelection';

export default function ShipmentPackageSelection(): JSX.Element {
  return (
    <ContentLayout>
      <SiteContent>
        <PackageSelection />
      </SiteContent>
    </ContentLayout>
  );
}
